export type ToastLevel = 'info' | 'warning' | 'error';

export interface ToastEventDetail {
  level: ToastLevel;
  message: string;
  durationMs?: number;
}

export const ESMART_TOAST_EVENT = 'esmart:toast';

let hasToastListener = false;
let queuedToasts: ToastEventDetail[] = [];

const dispatchToast = (detail: ToastEventDetail): void => {
  window.dispatchEvent(new CustomEvent<ToastEventDetail>(ESMART_TOAST_EVENT, { detail }));
};

export const notify = (detail: ToastEventDetail): void => {
  if (typeof window === 'undefined') return;

  if (!hasToastListener) {
    queuedToasts.push(detail);
    return;
  }

  dispatchToast(detail);
};

export const notifyWarning = (message: string, durationMs?: number): void => {
  notify({ level: 'warning', message, durationMs });
};

export const registerToastEventListener = (listener: EventListener): (() => void) => {
  if (typeof window === 'undefined') return () => undefined;

  window.addEventListener(ESMART_TOAST_EVENT, listener);
  hasToastListener = true;

  const toastsToFlush = queuedToasts;
  queuedToasts = [];
  toastsToFlush.forEach(dispatchToast);

  return () => {
    window.removeEventListener(ESMART_TOAST_EVENT, listener);
    hasToastListener = false;
  };
};
